import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { MinusSmIcon, PlusSmIcon } from "@heroicons/react/outline";

interface ProductDescriptionProps {
  description: string;
  productName: string;
}

export const ProductDescription = ({ description, productName }: ProductDescriptionProps) => (
  <Disclosure as="div" key={productName}>
    {({ open }) => (
      <>
        <DisclosureButton className="w-full py-6 flex justify-between items-center">
          <span className={`text-lg font-medium ${open ? "text-indigo-600" : "text-gray-900"}`}>
            Description
          </span>
          {open ? (
            <MinusSmIcon className="h-6 w-6 text-indigo-400" />
          ) : (
            <PlusSmIcon className="h-6 w-6 text-gray-400" />
          )}
        </DisclosureButton>
        <DisclosurePanel className="pb-6 prose prose-sm max-w-full">
          <div
            className="text-base text-gray-700 space-y-6"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </DisclosurePanel>
      </>
    )}
  </Disclosure>
);